module.exports = __webpack_public_path__ + "static/media/Whirlipede_gaussian2.4b022ce2.png";